export default __webpack_public_path__ + "static/media/tree.43a9370c.jpg";